import { Alert } from "~/common/mui/Alert/Alert";
import { useTranslation } from "react-i18next";

export const ErrorLoadingScreen = () => {
  const { t } = useTranslation();

  return <Alert severity="error">{t("addProduct.wsError")}</Alert>;
};
